import { UpdateSurgicalOrderClinicalRecord } from 'domain/usecases/surgical-order/update-surgical-order-clinical-record'
import { SurgicalOrderRepository } from 'repository/interfaces/surgical-order-repository'

export class RemoteUpdateSurgicalOrderClinicalRecord
  implements UpdateSurgicalOrderClinicalRecord
{
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  update(
    surgical_order_id: number,
    params: UpdateSurgicalOrderClinicalRecord.Params
  ): Promise<UpdateSurgicalOrderClinicalRecord.Model> {
    return this.surgicalOrderRepository.updateSurgicalOrderClinicalRecord(
      surgical_order_id,
      params
    )
  }
}

export type UpdateSurgicalOrderClinicalRecordModel =
  UpdateSurgicalOrderClinicalRecord.Model
